import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';
import {
  getCurrentQuizType,
  getHasFetchedQuizQuestions
} from '@selectors/quizTaking';
import useFailedAPIQueue from '@cont/Quiz/Taking/Common/useFailedAPIQueue';

const useLanding = () => {
  const { query } = useRouter();
  const { quizUID } = query;

  const { isSubjective } = useSelectorWithShallowEqual(getCurrentQuizType);
  const hasFetchedQuizQuestions = useSelectorWithShallowEqual(
    getHasFetchedQuizQuestions(quizUID)
  );

  const { startProcessingFailedAPIS } = useFailedAPIQueue();

  useEffect(() => {
    startProcessingFailedAPIS();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    isSubjective,
    hasFetchedQuizQuestions
  };
};

export default useLanding;
